import Table from "components/tables/table";
import { EntityCollection } from "models/list-user-entity-collection";
import { ListEntity } from "models/list-entity";
import { Fragment, FunctionComponent, useState } from "react";
import { useListUser } from "stores/hooks/list-user";
import EditEntityModal from "../entities/edit-entity-modal";
import AddEntityModal from "../entities/add-entity-modal";
import { useLocale } from "stores/hooks/locale";
import { ColumnInterface } from "components/tables/interfaces";
import { adminDoDeleteEntityCollection } from "services/admin/entity-collection";
import { useList } from "stores/hooks/list";
import { faPen, faUserSecret } from "components/icon-library";
import { addEntityCollectionColumns } from "lib/schema";
import { useTranslate } from "stores/hooks/translation";

interface MultiListEntityTableProps {
  listEntity: ListEntity;
  entityCollections: EntityCollection[];
  onUpdate: () => Promise<void>;
}

const MultiListEntityTable: FunctionComponent<MultiListEntityTableProps> = ({
  listEntity,
  entityCollections,
  onUpdate,
}) => {
  const translate = useTranslate();
  const locale = useLocale();
  const list = useList();
  const listUser = useListUser();
  const [add, toggleAdd] = useState(false);
  const [edit, toggleEdit] = useState<EntityCollection | undefined>(undefined);

  if (!list || !listUser) {
    return null;
  }

  const columns: ColumnInterface[] = [];
  addEntityCollectionColumns(
    listEntity.schema,
    locale,
    [{ ...listEntity }],
    columns,
    translate,
  );

  const onDelete = async (entityCollection: EntityCollection) => {
    // delete the collection, not the values
    await adminDoDeleteEntityCollection(
      list.uuid,
      listUser.uuid,
      listEntity.uuid,
      entityCollection.uuid,
    );

    // update
    onUpdate();
  };

  return (
    <Fragment>
      <Table
        name={`list-${listUser.list_uuid}-user-${listUser.uuid}-entity-${listEntity.uuid}`}
        columns={columns}
        data={entityCollections}
        adder={{
          text: "Lisää uusi",
          onClick: async () => toggleAdd(true),
        }}
        statuses={[{ check: (item) => item.secret, icon: faUserSecret }]}
        editers={[
          {
            onClick: async (item) => toggleEdit(item),
            icon: faPen,
          },
        ]}
        deleter={{ onClick: async (item) => onDelete(item) }}
      />
      {add && (
        <AddEntityModal
          listEntity={listEntity}
          onUpdate={onUpdate}
          onClose={async () => toggleAdd(false)}
        />
      )}
      {edit && (
        <EditEntityModal
          listEntity={listEntity}
          entityCollection={edit}
          onUpdate={onUpdate}
          onClose={async () => toggleEdit(undefined)}
        />
      )}
    </Fragment>
  );
};

export default MultiListEntityTable;
